import React, { useState } from 'react'
import { makeStyles } from "@material-ui/core";
import * as sweetalert from "sweetalert";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../../../navigation/Auth/auth";


export function useForm(initialFValues, validateOnChange = false, validate) {

    const navigate = useNavigate();
    const auth = useAuth();
    const location = useLocation();
  
    const [errors, setErrors] = useState({});
    const redirectPath = location.state?.path || "/dashboard";
    const [loginInput, setLogin] = useState({
        trans_id:"",
        payment_method: "",
        bank: "",
        number_transfer: "",
        image: "",
        mobile: "",
        national_id: "",
        name: "",
        amount: "",
        description:"",
      });
      const [values, setValues] = useState(loginInput);
    const handleInputChange = e => {
    
        const { name, value } = e.target
       
        setLogin({ ...loginInput, [name]: value });
   
        if (validateOnChange)
            validate({ [name]: value })
            
    }

    const resetForm = () => {
        setValues(initialFValues);
        setErrors({})
    }



    const addForm = () => {
        if (validate()) {
           
          }
        
    }

    return {
        loginInput,
        setLogin,
        errors,
        setErrors,
        handleInputChange,
        addForm,
        resetForm
    }
  
}


const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiFormControl-root': {
            width: '80%',
            margin: theme.spacing(1)
        }
    }
}))

export function Form(props) {

    const classes = useStyles();
    const { children, ...other } = props;
    return (
        <form className={classes.root} autoComplete="off" {...other}>
            {props.children}
        </form>
    )
}

